module.exports = __webpack_public_path__ + "media/img/private-venue/bg-hover-cheers-7b795d1f3f05075d5f959707378ccda0.png";